import { styled } from "styled-components";
import { QUERIES, getSearchSuggestions } from "@dataone/lib";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "antd";
import { SearchIcon } from "@dataone/icons";

interface SearchSuggestionsProps {
  search: string;
  databaseId: string;
  setSelectedSearch: React.Dispatch<React.SetStateAction<{ message: string }>>;
}

function SearchSuggestions({
  search,
  databaseId,
  setSelectedSearch,
}: SearchSuggestionsProps) {
  const searchRequest = {
    input: search,
    databaseId,
  };

  const { data: suggestions, isLoading } = useQuery({
    queryKey: [QUERIES.SEARCH_SUGGESTIONS, search],
    queryFn: () => getSearchSuggestions(searchRequest),
  });

  return (
    <StyledSearchSuggestions>
      {isLoading ? (
        <HistoryLoading>
          <Skeleton.Input active block size="small" />
          <Skeleton.Input active block size="small" />
          <Skeleton.Input active block size="small" />
        </HistoryLoading>
      ) : (
        suggestions?.suggestions.slice(0, 5).map((suggestion) => (
          <StyledContainer
            key={suggestion}
            onClick={() => setSelectedSearch({ message: suggestion })}
          >
            <StyledSearchIcon>
              <SearchIcon />
            </StyledSearchIcon>
            <div className="search-desc">{suggestion}</div>
          </StyledContainer>
        ))
      )}
    </StyledSearchSuggestions>
  );
}

export default SearchSuggestions;

const StyledContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  padding: 7px 0px;
  cursor: pointer;
  &:hover {
    background: #fff;
  }
  .search-desc {
    color: #000;
    font-size: 14px;
    font-weight: 300;
    max-width: 91%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
const StyledSearchSuggestions = styled.div`
  // overflow-y: auto;
  max-height: 250px;
  margin: 10px 0px;
  // &::-webkit-scrollbar {
  //   width: 10px;
  // }
  // &::-webkit-scrollbar-thumb {
  //   background-color: #8b8b8b;
  //   border-radius: 7px;
  // }
  // &::-webkit-scrollbar-button {
  //   display: block;
  //   height: 16px;
  //   width: 16px;
  //   border: none;
  // }
  // &::-webkit-scrollbar-button:single-button:vertical:decrement {
  //   height: 12px;
  //   width: 16px;
  //   background-position: center 6px;
  //   background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='50,00 0,50 100,50'/></svg>");
  // }
  // &::-webkit-scrollbar-button:single-button:vertical:increment {
  //   height: 12px;
  //   width: 16px;
  //   background-position: center center;
  //   background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='0,0 100,0 50,50'/></svg>");
  // }
`;

const HistoryLoading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px;
`;
const StyledSearchIcon = styled.div`
  margin: 0px 10px 0px 20px;
  font-size: 15px;
`;
